export const seconds = (el: any): string =>
{
    const date = new Date();

    return el + date.getMilliseconds();
};

export const ellipsisText = (text: string, toCut: number, separator = '...') =>
{
    if (!text)
        return text;

    const str = text.slice(0, toCut);

    if (text.length > toCut)
        return str.padEnd(toCut + 3, separator);
    else
        return str;
};

export const dataURLToBlob = (dataURL: string) =>
{
    const BASE64_MARKER = ';base64,';

    if (dataURL.indexOf(BASE64_MARKER) == -1)
    {
        const parts = dataURL.split(',');
        const contentType = parts[0].split(':')[1];
        const raw = decodeURIComponent(parts[1]);

        return new Blob([raw], { type: contentType });
    }

    const parts = dataURL.split(BASE64_MARKER);
    const contentType = parts[0].split(':')[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;

    const uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i)
    {
        uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], { type: contentType });
};

export const responsiveVideo = (content: string[] | string, save: boolean = false): string[] | string =>
{
    if (Array.isArray(content))
    {
        content.forEach((txt, index) =>
        {
            const container = document.createElement('div');

            container.innerHTML = txt;

            const video = container.querySelectorAll('video');
            const iframe = container.querySelectorAll('iframe');
            const elements = [...video, ...iframe];

            elements.forEach(el =>
            {
                setSize(el, save);
            });

            Array.isArray(content) ? content[index] = container.innerHTML : content;
        });
    }
    else
    {
        const container = document.createElement('div');

        container.innerHTML = content;

        const video = container.querySelectorAll('video');
        const iframe = container.querySelectorAll('iframe');
        const elements = [...video, ...iframe];

        elements.forEach(el =>
        {
            setSize(el, save);
        });

        content = container.innerHTML;
    }

    return content;
};

function setSize(el: HTMLVideoElement | HTMLIFrameElement, save: boolean): HTMLVideoElement | HTMLIFrameElement
{
    if (save)
    {
        const h = el.height;
        const w = el.width;

        el.style.height = 'auto';
        el.style.width = '100%';
        el.style.maxWidth = `${w}px`;
        el.style.aspectRatio = `${w} / ${h}`;
    }
    else
    {
        el.style.removeProperty('height');
        el.style.removeProperty('width');
        el.style.removeProperty('max-width');
        el.style.removeProperty('aspect-ratio');
    }

    return el;
}
